import { Box, Center, Flex, Stack, Text } from '@chakra-ui/react';
import { AddIcon, Avatar, Card } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

export interface MemberInfoCardProps {
  avatar: string;
  name: string;
  userid: string;
  onAddMember: () => void;
  onAvatarClick: () => void;
}

const MemberInfoCard = ({
  avatar,
  name,
  userid,
  onAddMember,
  onAvatarClick,
}: MemberInfoCardProps) => {
  const { t } = useTranslation();
  return (
    <Card>
      <Flex direction="column" gap="2">
        <Flex alignItems="center" gap="2.5">
          <Avatar
            src={avatar}
            size="sm"
            activeShake={true}
            cursor="pointer"
            flex="none"
            onClick={onAvatarClick}
          />
          <Stack
            flex="1"
            gap="0.5"
            minW="0"
            overflow="hidden"
            borderBottom="1px solid"
            borderColor="border.subtle"
            py="2.5"
          >
            <Flex fontSize="sm" fontWeight="semibold" alignItems="center" gap="0.5">
              <Text flex="1" truncate>
                {name}
              </Text>
            </Flex>
            <Text fontSize="xs" color="fg.muted">
              @{userid}
            </Text>
          </Stack>
        </Flex>
        <Flex alignItems="center" gap="2.5" cursor="pointer" onClick={onAddMember}>
          <Center fontSize="9xl">
            <AddIcon />
          </Center>
          <Box flex="1" py="2.5">
            <Text fontSize="sm" fontWeight="mediumBold">
              {t('action.addMembers')}
            </Text>
          </Box>
        </Flex>
      </Flex>
    </Card>
  );
};

const MemoizedMemberInfoCard = memo(MemberInfoCard);
export { MemoizedMemberInfoCard as MemberInfoCard };
